import { useState } from 'react';
import { Box } from '@mui/joy';
import embeddedLogo from '../brand/embeddedLogo';

export default function BrandLogo({ size = 40, sx }) {
  const [failed, setFailed] = useState(false);
  return <Box sx={{ width: size, height: size, flexShrink: 0, display: 'grid', placeItems: 'center', borderRadius: '25%', overflow: 'hidden', ...sx }}>
    {!failed ? <Box component="img" src={embeddedLogo} alt="Логотип LunaDesk" onError={() => setFailed(true)} sx={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}/>
      : <Box component="span" aria-label="LunaDesk" sx={{ fontSize: size * .4, fontWeight: 800, color: 'primary.plainColor' }}>LD</Box>}
  </Box>;
}
